import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_TEST_ID } from '../../constants';
import { OutOfStockStatus } from './CartOutOfStock.styles';

export const CartOutOfStock: FC = () => {
    const { t } = useTranslations();

    return (
        <OutOfStockStatus data-test={ORDER_CART_TEST_ID.OUT_OF_STOCK}>
            {t['order_cart.stock_status.out_of_stock']}
        </OutOfStockStatus>
    );
};
